import { Typography } from "@mui/material";
import React from "react";

export default function TextChangeBalance({
  type = "add",
  amount = "0",
  ...restProps
}) {
  return (
    <Typography
      variant="body2"
      color="#BFBFBF"
      {...restProps}
      fontSize={14}
    >
      <Typography variant="caption" fontWeight={700} fontSize={14}>
        {type === "add" ? "+" : "-"}${Number(amount).toLocaleString("en-US")}
        &nbsp;
      </Typography>
      <Typography variant="caption" fontSize={14}>USD</Typography>
    </Typography>
  );
}
